export default {
    welcome: "Dobro došli u Vašu prodavnicu.",
    welcomeMsg: "Na ovoj strani vidite 2 obavezna koraka za sve nove prodavnice. Morate dodati barem 1 proizvod, 1 opciju za dostavu i nakon toga ste spremni za prodaju.",
    products: {
        title: "Proizvodi",
        noProducts: "U Vašoj prodavnici trenutno nema proizvoda.",
        hasProducts: "Uspješno ste dodali Vaš prvi proizvod.",
        manageProducts: "Upravljanje proizvodima vršite direktno na strani ",
        addProducts: "Dodaj proizvode",
        buttonLabel: "Proizvodi"
    },
    delivery: {
        title: "Dostava",
        noDelivering: "Trenutno ne vršite dostavu vaših proizvoda.",
        addCities: "Dodajte gradove u kojima vršite dostavu",
        hasDelivering: "Uspješno ste odabrali gradove za dostavu.",
        manageCities: "Upravljanje dostavom vršite direktno na strani",
        buttonLabel: "Dostava"
    },
    verification: {
        title: "Verifikujte Vašu prodavnicu",
        fewStepsMore: "Ovaj korak nije obavezan, ali ukoliko ste registrovana kompanija dobićete poseban status na platformi.",
        companyDetails: "Pored naziva kompanije stojaće znak da ste provjereni, za veće povjerenje trgovaca.",
        help: "Verifikacija postaje dostupna nakon što se odrade prva 2 koraka lijevo.",
        readyForSale: "Ukoliko već niste, možete dodati proizvode i gradove za dostavu kako bi bili spremni za prodaju nakon verifikacije Vaše prodavnice.",
        verifyButton: "Verifikacija"
    },
    hereLink: "ovdje"
}
